import { ILingoLiftImportGoogleroomClass } from '../../features/lingoLiftClasses';

export const selectLingoLiftGoogleClassroomImportsParamsFromDomObject = (object: HTMLElement): Array<ILingoLiftImportGoogleroomClass> => {
  const courses = JSON.parse(object.dataset.courses ?? '');

  return courses;
};
